module.exports = __webpack_public_path__ + "static/media/download_file.0674a8bc.svg";